<template>
  <div class="card px-3 py-3 border-0 mb-3" data-cy="ad-card">
    <div v-if="horizontal" class="row oa">
      <div class="col-sm-4 d-flex flex-column justify-content-center align-items-stretch">
        <div class="bg ml-3" :class="ctaImageClass" />
      </div>
      <div class="col-sm-7 my-3">
        <div class="title text-left">
          <div v-for="title in ctaTitles" :key="title">{{ title }}</div>
        </div>
        <div class="content text-left my-4">{{ ctaContent }}</div>
        <mobialis-button @click="goToProduct" data-cy="learn-more-button" class="w-auto">{{
          chooseButtonLabel
        }}</mobialis-button>
      </div>
    </div>

    <div v-else>
      <div class="title text-center">
        <div v-for="title in ctaTitles" :key="title">{{ title }}</div>
      </div>
      <div class="d-flex justify-content-center">
        <div class="bg mt-4 mb-1" :class="ctaImageClass" />
      </div>
      <div class="content text-center p-4">{{ ctaContent }}</div>
      <mobialis-button @click="goToProduct" data-cy="learn-more-button">{{ chooseButtonLabel }}</mobialis-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'CtaCard',
  data() {
    return {
      defaultData: {
        default: {
          titles: [`${this.$t('message.reviews.ads.defaultTitle')}`],
          content: `${this.$t('message.reviews.ads.defaultContent')}`,
          buttonLabel: `${this.$t('message.reviews.ads.defaultButtonLabel')}`,
        },
        credit: {
          titles: [`${this.$t('message.reviews.ads.creditTitle')}`, `${this.$t('message.reviews.ads.creditSubtitle')}`],
          content: `${this.$t('message.reviews.ads.creditContent')}`,
          buttonLabel: `${this.$t('message.reviews.ads.buttonLabel')}`,
        },
        trade: {
          titles: [`${this.$t('message.reviews.ads.tradeTitle')}`],
          content: `${this.$t('message.reviews.ads.tradeContent')}`,
          buttonLabel: `${this.$t('message.reviews.ads.buttonLabel')}`,
        },
      },
    };
  },
  props: {
    titles: {
      type: Array,
      required: false,
      default: () => [],
    },
    content: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
    buttonLabel: {
      type: String,
      required: false,
      default: 'Learn More',
    },
    product: {
      type: String,
      required: false,
      default: 'credit',
      validator: s => ['credit', 'trade', 'default'].indexOf(s.toLowerCase()) >= 0,
    },
    horizontal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    chooseButtonLabel() {
      return this.defaultData[this.product].buttonLabel;
    },
    ctaImageClass() {
      return `${this.product.toLowerCase()}Image`;
    },
    ctaTitles() {
      return this.titles.length > 0 ? this.titles : this.defaultData[this.product].titles;
    },
    ctaContent() {
      return this.content ? this.content : this.defaultData[this.product].content;
    },
    isCredit() {
      return this.product === 'credit';
    },
  },
  methods: {
    goToProduct() {
      if (this.product === 'default') {
        this.$router.push({ name: `home-${this.baseRoute}` });
      } else {
        this.$router.push(this.$store.getters.getProductHomeRoute(this.product));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.oa {
  overflow: visible;
}
.bg {
  height: 170px;
  width: 220px;
}
.title {
  font-size: 22px;
  font-weight: bold;
}
.content {
  font-size: 16px;
}
.isDesktop {
  background-position: left;
}
.isMobile {
  background-position: center;
}
.pushdown {
  padding-top: 1.5em;
}
.defaultImage {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url('../../assets/Interest-Rate-Mockup.svg');
}
.creditImage {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url('../../assets/Interest-Rate-Mockup.svg');
}
.tradeImage {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url('../../assets/Interest-Trade-in-Mockup.svg');
}
</style>
